import { render, staticRenderFns } from "./TutorialCard.vue?vue&type=template&id=45bd3049&scoped=true&"
import script from "./TutorialCard.vue?vue&type=script&lang=js&"
export * from "./TutorialCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bd3049",
  null
  
)

export default component.exports